import React, { useState } from 'react';
import ExportMenu, { FORMATS } from './ExportMenu';
import { exportService } from '../../services/accounting/export.service';

/**
 * Export dropdown of a report (BE-14b): PDF and CSV of `reportType` with the page's own filters (`params`).
 * `onError(message)` shows a failed export on the page.
 */
const ReportExportMenu = ({ reportType, params, onError, formats = ['pdf', 'csv'], label }) => {
  const [busy, setBusy] = useState(false);

  const handleExport = async (format) => {
    setBusy(true);
    try {
      await exportService.download(reportType, format, params);
    } catch (err) {
      if (onError) onError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <ExportMenu
      onExport={handleExport}
      busy={busy}
      label={label}
      formats={FORMATS.filter((f) => formats.includes(f.key))}
    />
  );
};

export default ReportExportMenu;
